import { render, staticRenderFns } from "./typeRobeAction.vue?vue&type=template&id=5980f748&scoped=true"
import script from "./typeRobeAction.vue?vue&type=script&lang=js"
export * from "./typeRobeAction.vue?vue&type=script&lang=js"
import style0 from "./typeRobeAction.vue?vue&type=style&index=0&id=5980f748&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5980f748",
  null
  
)

export default component.exports